/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.0
 */

export const BASKET_SHOW_LOADER = '@@b2b_portal_ui/basket/BASKET_SHOW_LOADER';
export const BASKET_CLEAN_LIST = '@@b2b_portal_ui/basket/BASKET_CLEAN_LIST';

export const BASKET_GET_LIST_START = '@@b2b_portal_ui/basket/BASKET_GET_LIST_START';
export const BASKET_GET_LIST_SUCCESSFUL = '@@b2b_portal_ui/basket/BASKET_GET_LIST_SUCCESSFUL';
export const BASKET_GET_LIST_FAILED = '@@b2b_portal_ui/basket/BASKET_GET_LIST_FAILED';

export const BASKET_SET_INIT_LIST = '@@b2b_portal_ui/basket/BASKET_SET_INIT_LIST';
